import React, { useEffect, useState } from 'react';

import logo from "../layouts/assets/img/AdminLTELogo.png";
import userProfilePic from "../layouts/assets/img/user2-160x160.jpg";

import { getAuth, signOut, onAuthStateChanged } from "firebase/auth";
import { useNavigate } from 'react-router-dom';

import { useAppSelector, useAppDispatch } from '../../config/hooks'

import { myFirestore } from '../../config/MyFirebase';
import { collection, query, DocumentData, getDocs, onSnapshot } from 'firebase/firestore';



export default function AsideMenu(

    {
        userId,
        dateMessages,
        getMessageOf
    }:
        {
            userId: string,
            dateMessages: any[],
            getMessageOf: (userId: string, dateMessage: DocumentData) => void
        }) {

    // const [dateMessages, setDateMessages] = useState<any[]>([]);
    const [messages, setMessages] = useState<string[]>([]);
    // const [userId, setUserId] = useState('');

    const user = useAppSelector((state) => state.user.user)
    //const dispatch = useAppDispatch()


    const navigate = useNavigate();

    // const getDateMessages = () => {

    //     const auth = getAuth();

    //     onAuthStateChanged(auth, async (user) => {
    //         if (user) {
    //             // User is signed in, see docs for a list of available properties
    //             // https://firebase.google.com/docs/reference/js/auth.user
    //             const uid = user.uid;
    //             setUserId(uid);
    //             console.log("temp: ", uid)

    //             // ...
    //             const q = query(collection(myFirestore, "users", uid, "date_messages"));
    //             const unsubscribe = onSnapshot(q, (querySnapshot) => {
    //                 let dateMessages: any[] = [];
    //                 querySnapshot.forEach((doc) => {

    //                     dateMessages.push(doc.data());

    //                 });
    //                 //setDateMessages(dateMessages);
    //             });
    //         } else {
    //             // User is signed out
    //             // ...
    //         }
    //     });

    // }

    const getMessagesOf = (dateMessage: DocumentData) => {
        console.log("dans l'enfant...avant de lancer: ", dateMessage);
        getMessageOf(userId, dateMessage);

    }

    useEffect(() => {
        //console.log("aside user id: ", user.id)
        //getDateMessages();

    }, [])

    const logout = () => {

        const auth = getAuth();
        signOut(auth).then(() => {
            // Sign-out successful.
            navigate('/');

        }).catch((error) => {
            // An error happened.
        });

    }

    const formatDate = (date: Date): string => {
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Les mois commencent à 0
        const year = date.getFullYear();

        return `${day}/${month}/${year}`;
    };



    return (
        <>
            <aside className="main-sidebar sidebar-dark-primary elevation-4">
                <a href="" className="brand-link">
                    {/* <img src={logo} alt="AdminLTE Logo" className="brand-image img-circle elevation-3" style={{ opacity: ".8" }} /> */}
                    <span className="ml-3 brand-text font-weight-light"><b>Copy&</b>Paste</span>
                </a>

                <div className="sidebar">
                    <div className="user-panel mt-3 pb-3 mb-3 d-flex align-items-center">
                        <div className="image">
                            {/* <img src={userProfilePic} className="img-circle elevation-2" alt="User Image" /> */}
                            <div className="avatar">{user.name[0]}</div>

                        </div>
                        <div className="info">
                            <a href="#" className="d-block">{user.name}</a>
                            {/* <a href="#" className="d-block">{user.title_subscription} : {user.max_message_duration} min</a> */}
                        </div>
                        {/* <a href="#" className="d-block">{user.name}</a> */}

                    </div>

                    <div className="form-inline">
                        <div className="input-group" data-widget="sidebar-search">
                            <input className="form-control form-control-sidebar" type="search" placeholder="Search" aria-label="Search" />
                            <div className="input-group-append">
                                <button className="btn btn-sidebar">
                                    <i className="fas fa-search fa-fw"></i>
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* <!-- Sidebar Menu --> */}
                    <nav className="mt-2">
                        <ul className="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
                            {/* <!-- Add icons to the links using the .nav-icon className
             with font-awesome or any other icon font library --> */}


                            {dateMessages && dateMessages.map((dateMessage, index) => {


                                return <li onClick={() => getMessagesOf(dateMessage)} key={dateMessage.id} className="nav-item">
                                    <a href="#" className="nav-link">
                                        <i className="far fa-circle nav-icon"></i>
                                        <p>
                                            {formatDate(dateMessage.timestamps.toDate())}
                                        </p>
                                    </a>
                                </li>

                            })}
                            <li className="nav-item">
                                <a href="#" onClick={logout} className="nav-link active">
                                    <i className="nav-icon fas fa-sign-out-alt"></i>
                                    <p>
                                        Logout
                                    </p>
                                </a>
                            </li>
                        </ul>
                    </nav>
                    {/* <!-- /.sidebar-menu --> */}
                </div>
                {/* <!-- /.sidebar --> */}
            </aside>
        </>
    )
}
